import "./SideItem.css";
import { Group, Text } from "@mantine/core";
import { IconCreditCard, IconUser, IconFileDescription } from "@tabler/icons-react";

type ComponentProps = {
    label: string,
    icon: string,
    isSelected: boolean,
    onPress: () => void
}

const SideItem = (props: ComponentProps) => {
    return(        
        <Group onClick={props.onPress} style={{ cursor: "pointer" }}>
            { props.icon === "credit_card" && <IconCreditCard style={{ opacity: .3, color: props.isSelected ? "orange" : 'black' }} /> }
            { props.icon === "person" && <IconUser style={{ opacity: .3, color: props.isSelected ? "orange" : 'black' }} /> }
            { props.icon === "file_description" && <IconFileDescription style={{ opacity: .3, color: props.isSelected ? "orange" : 'black' }} /> }
            <Text style={{ color: props.isSelected ? "orange" : 'black', fontWeight: props.isSelected ? 700 : 300 }}>{ props.label }</Text>
        </Group>
    );
};

export default SideItem;